import { useEffect, useState } from 'react';
import { useFormV2 } from '@abyss/web/hooks/useForm';
import { useOverlay } from '@abyss/web/hooks/useOverlay';

const sampleMenuItems = [
  {
    title: 'Home',
    url: '/',
    icon: 'home_work',
  },
  {
    title: 'Dashboard',
    url: '/dashboard',
    icon: 'storage',
  },
];

const LeftMenuController = () => {
  const drawer = useOverlay('menu-drawer');
  const [navItems, setNavItems] = useState<Array<any>>([]);
  const [menuItems, setMenu] = useState<Array<any>>(sampleMenuItems);
  const [expandedMenuItems, setExpandedMenuItems] = useState<{
    [key: string]: boolean;
  }>({});
  const form = useFormV2({
    defaultValues: {
      search: '',
    },
  });

  const saveMenuState = (state: { [key: string]: boolean }) => {
    setExpandedMenuItems(state);
  };

  const handleMenuToggle = (itemId: string, isExpanded: boolean) => {
    setExpandedMenuItems({ ...expandedMenuItems, [itemId]: isExpanded });
    saveMenuState({ ...expandedMenuItems, [itemId]: isExpanded });
  };

  const TransformToAbyss = (item: any) => {
    const itemId = item.title.toString().replace(/\s+/g, '-').toLowerCase();
    return {
      id: itemId,
      isOpenByDefault: expandedMenuItems[itemId] || false,
      onToggle: (isExpanded: boolean) => handleMenuToggle(itemId, isExpanded),
      title: item.title,
      href: item.url,
    };
  };

  const UpdateNavMenuItems = (mItems: Array<any>) => {
    const items = mItems.map((item: any) => TransformToAbyss(item));
    setNavItems(items);
  };

  // Simple search filter for boilerplate
  const Action = {
    SearchMenu: (value?: string) => {
      const searchValue = (
        value ??
        form.getValues().search ??
        ''
      ).toLowerCase();
      if (!searchValue) {
        setMenu(sampleMenuItems);
        UpdateNavMenuItems(sampleMenuItems);
      } else {
        const filtered = sampleMenuItems.filter((item) =>
          item.title.toLowerCase().includes(searchValue)
        );
        setMenu(filtered);
        UpdateNavMenuItems(filtered);
      }
    },
    OnLinkClick: (e: any) => {
      // Navigation handled by router link, nothing needed for boilerplate
    },
    ShowMenu: () => {
      drawer.open();
    },
    ShowFeedback: () => {},
  };

  // Initialize nav items
  useEffect(() => {
    UpdateNavMenuItems(menuItems);
  }, [menuItems]);

  return {
    menuItems,
    form,
    Action,
    navItems,
    setNavItems,
    expandedMenuItems,
    setExpandedMenuItems,
    saveMenuState,
  };
};

export { LeftMenuController };
